import type { FaireProductEntity } from "../../entity_types/product";

export const p_dprpbkrbqq: FaireProductEntity = {
  token: "p_dprpbkrbqq",
  type: "product",
  name: "Hot Chef Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/87a8e2f012eb5dea9b65e01059bb26eb3b59e95aaa16398e7da87d70a9c39aae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67a9427bc04ca2b2198b74a8f8d66364840e1d3c4b7127c650fe45216e0460c9.jpeg",
    "https://cdn.faire.com/fastly/9ede41ae49ffe12cb8306d34339abee835d4aae5bac96802f6dd7a558d52fae2.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/833e75442f8a9a3f4035496d36f1fba8190d778e8bd8574631921965f670b534.jpeg",
    "https://cdn.faire.com/fastly/6817eafb571bbef966a7df2ba61191b9cc4cd389334cf8f95915be956fbdf761.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks bring a whole new meaning to \"Yes, Chef!\" 🤤\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:13.067Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
